export default __webpack_public_path__ + "static/media/mylist.aff522e8.png";